// extracted by mini-css-extract-plugin
module.exports = {"Settings":"style_Settings__2l0Y5","button":"style_button__1ZdLi","isActive":"style_isActive__3SGi0"};